<template>
  <section class="search-client" v-if="filterSettings">
    <template v-if="!errorMessage">
      <form @submit.prevent="getClient">
        <div v-if="clientType !== 3 && this.productType !== 2" class="border rounded pt-4 pb-4 mb-5">
          <div class="row">
            <div class="col-4" v-if="!filterSettings.person.disabled">
              <checkbox-field
                  v-model="filter.person"
                  :disabled="this.loading || this.$user.role === 4 || (this.productType === 1 && !this.filter.resident) || this.showOtp"
                  placeholder="Физ. лицо"
                  id="client.filter.person"
                  class="form-check-sm justify-content-center"
              />
            </div>
            <div class="col-4" v-if="!filterSettings.resident.disabled">
              <checkbox-field
                  v-model="filter.resident"
                  :disabled="this.loading || this.$user.role === 4 || (this.productType === 1 && !this.filter.person) || this.showOtp"
                  placeholder="Резидент"
                  id="client.filter.resident"
                  class="form-check-sm justify-content-center"
              />
            </div>
            <div class="col-4" v-if="!filterSettings.verify.disabled">
              <checkbox-field
                  v-model="filter.verify"
                  :disabled="this.loading || !this.filter.resident || this.showOtp"
                  placeholder="Верификация"
                  id="client.filter.verify"
                  class="form-check-sm justify-content-center"
              />
            </div>
          </div>
        </div>
        <template v-if="filterStep !== 1">
          <input-mask-field
              v-if="this.filter.person && this.filter.resident"
              v-model="main.phone"
              id="main.phone"
              name="main_phone"
              :disabled="this.loading || this.showOtp"
              :required="true"
              :mb="5"
              placeholder="Номер телефона"
              mask="+7(###) ###-####"
              type="text"
          />
          <input-mask-field
              v-if="this.filterStep === 0 || this.filterStep === 2"
              v-model="main.iin"
              id="main.iin"
              name="main_iin"
              :disabled="this.loading || this.showOtp"
              :required="true"
              :has-error="hasIin || innErr"
              :mb="5"
              mask="### ### ### ###"
              :placeholder="this.filterStep === 0 ? 'ИИН' : 'БИН'"
              type="text"
          >
            <div v-if="hasIin" id="main.iin" class="invalid-feedback text-center opacity-75">
              ИИН <b>{{ main.iin }}</b> уже указан.
            </div>
            <div v-if="innErr" id="main.iin" class="invalid-feedback text-center opacity-75">
              {{innErr}}
            </div>
          </input-mask-field>
          <input-field
              v-if="this.filterStep === 3"
              v-model="main.name"
              id="main.name"
              name="main_name"
              :disabled="this.loading"
              :required="this.filterStep !== 1"
              :placeholder="'Наименование организации'"
              type="text"
              mb="5"
          />
        </template>
        <template v-else>
          <div class="file-upload_field" :class="!docEnd ? 'pt-4 pb-5 px-5' : ''">
            <div v-if="!docEnd" >
              <div class="file-upload_upload">
                <input type="file" accept=".png, .jpg, .jpeg" v-on:change="changeFile">
                <i class="ki-duotone ki-cloud-download fs-4x">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </i>
                <div class="fs-5 text-primary">Загрузите Паспорт</div>
                <small class="text-gray-400">Поддерживаются только файлы: png, jpg, jpeg</small>
                <br>
                <small class="text-gray-400">Размер файлов должен быть не более 4 Мб и не менее 100 Кб</small>
              </div>
            </div>
            <div v-else class="file-upload_file position-relative">
              <div v-if="!loading" class="deleted-image" @click="deletedFile">
                <i class="ki-duotone ki-trash-square fs-4tx text-white">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                  <span class="path4"></span>
                </i>
              </div>
              <div v-else class="loading-document">
                <div class="full__loader_text text-gray-700">Идет распознавание документа...</div>
              </div>
              <img style="width: 100%; border-radius: 6px;" :src="docEnd" alt="">
            </div>
          </div>
          <div class="mt-2 text-center">
            <small class="text-gray-600">Просим вас загружать файлы, чтобы четко и полностью был виден документ, без размытия. Документ должен быть расположен на одном листе.</small>
          </div>
        </template>
        <button
            v-html="this.loading ? 'Идет поиск...' : 'Поиск'"
            :disabled="this.loading || this.hasIin"
            v-if="checkClient && !innErr"
            class="btn btn-sm btn-primary w-100"
            type="submit">
        </button>
        <div v-if="this.showOtp">
          <input-mask-field
              v-model="otp"
              id="otp"
              name="otp"
              :disabled="this.loading"
              :placeholder="'Введите код из СМС'"
              mask="####"
              type="text"
              mb="5"
          />
          <button
              v-if="otp && otp.length === 4"
              v-html="this.loading ? 'Идет подтверждение...' : 'Подтвердить код'"
              :disabled="this.loading"
              class="btn btn-sm btn-warning w-100"
              @click="sendOtpCode"
              type="button">
          </button>
          <button
              v-else
              v-html="this.loading ? 'Идет проверка...' : 'Проверить согласие'"
              :disabled="this.loading"
              class="btn btn-sm btn-primary w-100"
              @click="checkKdp"
              type="button">
          </button>
        </div>
      </form>
      <button
          v-if="showForceKdp"
          @click="getForceKdp"
          v-html="'Отправить согласие повторно'"
          class="btn btn-sm btn-primary w-100"
          type="submit">
      </button>
    </template>
    <div v-if="errorMessage" class="text-gray-500 pt-3 text-center">
      <span class="text-gray-600 fs-5 fw-bold">Не смогли найти клиента.</span> <br>
      Вы можете
      <span
          class="text-primary cursor-pointer"
          @click="createClient"
      >создать клиента</span>
      или
      <span class="text-danger cursor-pointer" @click="clearForm">сбросить форму</span>
    </div>
  </section>
</template>

<script>
// Fields
import InputMaskField from '@/components/Fields/InputMaskField'
import CheckboxField  from '@/components/Fields/CheckboxField'
import InputField     from '@/components/Fields/InputField'
// Other
import axios      from 'axios'
import crypto     from "@/helpers/crypto";

export default {
  name: 'CustomerSearch',
  components: { InputMaskField, CheckboxField, InputField },
  emits: ['createClient', 'changeFilterStep'],
  props: {
    isClear: {
      type: Boolean,
      default: false
    },
    clientAddedList: {
      type: Array,
      default: () => []
    },
    afterSet: {
      type: Object,
      default: null
    },
    clientType: {
      type: Number,
      default: 0
    },
    filterSettings: {
      type: Object,
      default: null
    },
    productType: {
      type: Number,
      default: 0
    },
    module: {
      type: Function,
      required: true
    },
    ulid: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      filter: {
        resident: true,
        person:   true,
        verify:   true,
      },
      main: {
        phone: '7',
        iin:   ''
      },
      showForceKdp: false,
      errorMessage: '',
      checkClient:  false,
      filterStep:   0,
      loading:      false,
      hasIin:       false,
      info:         null,
      innErr:       '',
      showOtp:      false,
      otp:          null,
      doc:          null,
      docEnd:       null,
      task_id:      null,
      isResident:   true
    }
  },
  methods: {
    clearForm() {
      this.errorMessage = ''
      this.checkClient  = false
      this.filterStep   = 0
      this.loading      = false
      this.filter       =
          {
            resident: this.filterSettings ? this.filterSettings.resident.value : true,
            person:   this.filterSettings ? this.filterSettings.person.value   : true,
            verify:   this.filterSettings ? this.filterSettings.verify.value   : true
          }
      this.main         = this.module.Client.empty().main
      this.info         = null
      this.step         = 0
      this.doc          = null
      this.docEnd       = null
      this.task_id      = null
    },
    getClient() {
      this.loading = true
      const headers = Object.assign(
          structuredClone(this.filter),
          structuredClone(this.main),
          {step: this.filterStep, insurer: this.clientType === 1}
      )
      axios.post('/api/client/get', headers)
          .then(res => {
            if (res.data.length > 0) {
              this.setClientData(res.data)
            } else {
              if ('status' in res.data) {
                this.innErr = res.data.message
                const statuses = [2, 3, 6]
                if (statuses.includes(res.data.status)) this.showForceKdp = true
                if (res.data.status === 10) this.showOtp = true
              } else {
                this.$notifyError(res.data)
              }
            }
            this.loading = false
          })
          .catch(err => {
            this.$notifyError(err)
            this.loading = false
          })
    },
    getForceKdp() {
      this.loading  = true
      const headers = this.main
      axios.post('/api/client/force-kdp', headers)
          .then(res => {
            if (res.data.hasOwnProperty('result') && res.data.result) {
              this.$notifySuccess(res.data, {title: 'Обработано', text: 'Запрос отправлен на КДП'})
            } else {
              this.$notifyError(res.data)
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => {
            this.showForceKdp = false
            this.loading      = false
            this.innErr       = null
          })
    },
    createClient() {
      if (this.isResident) {
        const client = structuredClone(this.main)
        const filter = structuredClone(this.filter)
        this.$emit('createClient', {data: {client, filter}, step: 2})
      } else {
        const filter = structuredClone(this.filter)
        const client = structuredClone(this.main)
        this.isResident = true
        this.$emit('createClient', {data: {client, filter}, step: 2})
      }
    },
    changeFile(e) {
      this.doc   = e.target.files[0];
      this.checkFile(this.doc).then(res => {
        if (res.result) {
          let reader = new FileReader();
          reader.readAsDataURL(this.doc);
          reader.onload = e => { this.docEnd = e.target.result }
          this.uploadFile()
        } else {
          this.$notifyError(res)
        }
      })
    },
    async checkFile(file) {
      return new Promise((resolve) => {
        if (!file) return resolve({result: false, message: 'Файл не выбран'})
        const allowedTypes = ['image/png', 'image/jpeg']
        const allowedExtensions = ['png', 'jpg', 'jpeg']

        const fileName = (file.name || '').toLowerCase()
        const fileExt  = fileName.includes('.') ? fileName.split('.').pop() : ''

        if (!allowedExtensions.includes(fileExt)) {
          return resolve({result: false, message: 'Поддерживаются только файлы JPEG/JPG и PNG. Форматы типа JFIF, WEBP и другие не принимаются.'})
        }

        if (!allowedTypes.includes(file.type)) {
          return resolve({result: false, message: 'Поддерживаются только файлы PNG и JPG (JPEG). Форматы типа JFIF, WEBP и другие не принимаются.'})
        }

        if (file.size < 100 * 1024) {
          return resolve({result: false, message: 'Размер файла меньше 100 КБ'})
        }

        if (file.size > 4 * 1024 * 1024) {
          return resolve({result: false, message: 'Размер файла больше 4 МБ'})
        }

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
          let img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            if (img.width < 500 || img.height < 500) return resolve({result: false, message: 'Некачественное изображение. Пожалуйста, загрузите файл лучшего качества.'})
            resolve({result: true})
          }
        }
      })
    },
    deletedFile() {
      this.doc    = null
      this.docEnd = null
    },
    uploadFile() {
      const config  = {headers: {'content-type': 'multipart/form-data'}}
      let data      = new FormData();
      this.loading  = true
      data.append('document', this.doc);
      if (this.ulid) data.append('ulid', this.ulid);
      axios.post('/api/client/recognize-upload', data, config)
          .then(res => {
            if (res.data.result) {
              this.task_id = res.data.task_id
              this.getData()
            } else {
              this.$notifyError(res.data)
              this.clearAfterError()
            }
          })
          .catch(err => {
            console.log(err)
            this.clearAfterError(err.response.data.message ?? err.message)
          })
    },
    getData() {
      setTimeout(() => {
        if (this.task_id) {
          axios.post('/api/client/recognize-data', {task_id:this.task_id})
              .then(res => {
                if (res.data.hasOwnProperty('result')) {
                  if (res.data.result === false) {
                    this.$notifyError(res.data)
                    this.clearAfterError();
                  } else if (res.data.result === 1) {
                    this.loading = false
                    this.$emit('createClient', {data: structuredClone(res.data), step:2, driver: this.driver, scan:structuredClone(res.data.scan)})
                  } else if (res.data.result === 2) {
                    this.clearAfterError(res.data.message)
                  } else if (res.data.result === 3) {
                    if (this.clientAddedList.includes(res.data.data[0].document?.number)) {
                      this.clearAfterError('Клиент с документом "'+res.data.data[0].document?.number+'" уже есть в списке')
                    } else {
                      this.clearAfterError()
                      this.setClientData(res.data.data, res.data.scan)
                    }
                  } else {
                    this.getData()
                  }
                } else {
                  this.clearAfterError(res.data.message)
                }
              })
              .catch(err => {
                this.clearAfterError(err.message)
              })
        } else {
          this.clearAfterError('Не найден task_id')
        }
      }, 2000)
    },
    setClientData(data, scan) {
      data.forEach(item => {
        if (this.module.Modal.infoBlock('driver', this.clientType)) {
          let driver = {
            age_experience_id: 0,
            experience:        false,
            pensioner:         false,
            age:               0,
          }
          driver.age = this.calculateAge(item.client.birthday)
          driver.age_experience_id = driver.age >= 25 ? 4 : 2
          item['driver']      = structuredClone(driver)
        } else {
          delete item.class
        }
        if (this.module.Modal.infoBlock('bank', this.clientType)) {
          let bank = {
            name: null,
            kbe:  null,
            bik:  null,
            iik:  null,
          }
          item['bank'] = structuredClone(bank)
        }
        item['beingVerify'] = false
      })
      this.$emit('createClient', {data:data, step:1, driver: this.driver, scan: structuredClone(scan)})
    },
    calculateAge(birthday) {
      if (!birthday) return 0;

      const birthDate = new Date(birthday);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();

      const birthdayPassed =
          today.getMonth() > birthDate.getMonth() ||
          (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

      if (!birthdayPassed) {
        age--;
      }

      return age;
    },
    clearAfterError(message = null) {
      this.loading = false
      this.doc     = null
      this.task_id = null
      this.docEnd  = null
      if (message) {
        this.$notifyError({message: message})
      }
    },
    checkKdp() {
      this.loading = true
      axios.get('api/kdp/check-status', {params: {iin: this.main.iin.replace(/ /g,'')}}).then(res => {
        let data = JSON.parse(crypto.decryptBackend(res.data))
        if (data.isKdpAccepted) {
          this.$notifySuccess({message: 'Клиент предоставил согласие'})
          this.getClient()
        } else {
          this.$notifyError({message: "Клиент ещё не предоставил согласие"})
          this.loading = false
        }
      })
    },
    sendOtpCode() {
      this.loading = true
      axios.post('api/kdp/accept', {iin: this.main.iin.replace(/ /g,''), code: this.otp}).then(res => {
        if (res.data.result) {
          this.$notifySuccess({message: 'Код подтвержден'})
          this.getClient()
        } else {
          this.$notifyError(res.data)
          this.loading = false
        }
      }).catch(err => {
        this.$notifyError(err)
        this.loading = false
      })
    }
  },
  watch: {
    main: {
      deep: true,
      immediate: true,
      handler (newValue) {
        if (newValue.hasOwnProperty('phone')) if (newValue.phone.length === 0) this.main.phone = '7'
        if (newValue.hasOwnProperty('iin')) {
          if (newValue && newValue.iin.length === 15) {
            let iin     = newValue.iin.replace(/ /g,'')
            this.hasIin = this.clientAddedList.indexOf(iin) >= 0
          } else {
            this.showForceKdp = false
            this.hasIin       = false
            this.innErr       = ''
          }
        }
        this.checkClient = !!this.module.Validator.formMain(this.filterStep, newValue);
      }
    },
    filter: {
      deep: true,
      handler (newValue) {
        const step      = this.module.Client.filterStep(newValue)
        this.main       = this.module.Client.searchValues(step)
        this.filterStep = step
        this.$emit('changeFilterStep', step)
      }
    },
    isClear: {
      immediate: true,
      handler(val) {
        if (val) this.clearForm()
      }
    },
    afterSet: {
      deep: true,
      handler (newValue) {
        if (newValue) {
          this.main   = newValue.main
          this.filter = newValue.filter
        } else {
          this.main   = {
            phone: '+7',
            iin:   ''
          }
          this.filter = {
            resident: true,
            person:   true,
            verify:   true
          }
        }
      }
    },
    'filter.resident': {
      immediate: true,
      handler(val) {
        this.filter.verify = val
      }
    },
    filterSettings: {
      immediate: true,
      handler(val) {
        if (val) {
          this.filter = {
            resident: val ? this.filterSettings.resident.value : true,
            person:   val ? this.filterSettings.person.value   : true,
            verify:   val ? this.filterSettings.verify.value   : true
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>